import React, { useState, useEffect, useRef } from 'react';
//import { useAuth } from '../../context/AuthContext';
import contractService from '../../services/contractService';
//const { currentUser } = useAuth();
const CommentForm = ({ onAddComment, contractId }) => {
  
  const [comment, setComment] = useState('');
  const [loading, setLoading] = useState(false);
  const [showMentions, setShowMentions] = useState(false);
  const [mentionPosition, setMentionPosition] = useState(0);
  const [mentionQuery, setMentionQuery] = useState('');
  const [users, setUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const textareaRef = useRef(null);
  
  // Charger les utilisateurs pour les mentions
  useEffect(() => {
    const fetchUsers = async () => {
      const result = await contractService.getUsersForMentions();
      if (result.success) {
        setUsers(result.data);
      }
    };
    
    fetchUsers();
  }, []);
  
  // Filtrer les utilisateurs en fonction de la requête de mention
  useEffect(() => {
    if (mentionQuery) {
      const filtered = users.filter(user => 
        user.username.toLowerCase().includes(mentionQuery.toLowerCase())
      );
      setFilteredUsers(filtered);
    } else {
      setFilteredUsers(users);
    }
  }, [mentionQuery, users]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!comment.trim()) return;
    
    try {
      setLoading(true);
      await onAddComment(comment);
      setComment('');
    } finally {
      setLoading(false);
    }
  };
  
  const handleChange = (e) => {
    const value = e.target.value;
    setComment(value);
    
    // Détecter si l'utilisateur tape @ pour les mentions
    const lastAtPos = value.lastIndexOf('@');
    
    if (lastAtPos !== -1 && (lastAtPos === 0 || value[lastAtPos - 1] === ' ')) {
      // Extraire la requête de mention
      const query = value.substring(lastAtPos + 1).split(' ')[0];
      setMentionQuery(query);
      setMentionPosition(lastAtPos);
      setShowMentions(true);
    } else {
      setShowMentions(false);
    }
  };
  
  const handleMentionClick = (username) => {
    // Insérer le nom d'utilisateur mentionné dans le commentaire
    const before = comment.substring(0, mentionPosition);
    const after = comment.substring(mentionPosition + mentionQuery.length + 1);
    
    const newComment = `${before}@${username} ${after}`;
    setComment(newComment);
    
    // Fermer la liste des mentions
    setShowMentions(false);
    
    // Mettre le focus sur le textarea
    if (textareaRef.current) {
      textareaRef.current.focus();
    }
  };
  
  // Fermer la liste des mentions lorsque l'utilisateur clique en dehors
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        textareaRef.current && 
        !textareaRef.current.contains(e.target) &&
        !e.target.closest('.mentions-list')
      ) {
        setShowMentions(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  
  return (
    <div className="relative" id="comment-form">
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="comment" className="block text-sm font-medium text-gray-700 mb-1">
            Ajouter un commentaire
          </label>
          <div className="relative">
            <textarea
              ref={textareaRef}
              id="comment"
              name="comment"
              rows="3"
              value={comment}
              onChange={handleChange}
              className="block w-full border-gray-300 rounded-md shadow-sm focus:ring-primary-500 focus:border-primary-500 sm:text-sm"
              placeholder="Entrez votre commentaire ici... Utilisez @ pour mentionner un utilisateur"
              disabled={loading}
            ></textarea>
            
            {/* Liste des mentions */}
            {showMentions && filteredUsers.length > 0 && (
              <div className="mentions-list absolute z-10 bg-white rounded-md shadow-lg border border-gray-200 max-h-48 overflow-y-auto w-64">
                {filteredUsers.map((user) => (
                  <div
                    key={user._id}
                    className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                    onClick={() => handleMentionClick(user.username)}
                  >
                    @{user.username}
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
        <button
          type="submit"
          className="btn btn-primary"
          disabled={loading || !comment.trim()}
        >
          {loading ? 'Envoi en cours...' : 'Ajouter un commentaire'}
        </button>
      </form>
    </div>
  );
};

export default CommentForm;